import { useSelector } from 'react-redux';

import { makeStyles } from '@mui/styles';
import { RootState, ToastStore } from '@stores/models/store';
import { SnackbarProvider } from 'notistack';
import OverrideTheme from 'themes/custom-theme-helper';

import Toast from './components/Toast';

const ToastList = (): JSX.Element => {
  const toast = useSelector<RootState, ToastStore[]>((state) => state.toast);

  const useStyles = makeStyles(() => ({
    variantSuccess: {
      backgroundColor: OverrideTheme.colors.success,
    },
    variantError: {
      backgroundColor: OverrideTheme.colors.error,
    },
    variantInfo: {
      backgroundColor: OverrideTheme.colors.info,
    },
    variantWarning: {
      backgroundColor: OverrideTheme.colors.warning,
    },
  }));

  const classes = useStyles();

  return (
    <SnackbarProvider
      classes={
        {
          variantSuccess: classes.variantSuccess,
          variantError: classes.variantError,
          variantInfo: classes.variantInfo,
          variantWarning: classes.variantWarning,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any
      }
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {toast.map((toast) => (
        <Toast toast={toast} key={toast.id} />
      ))}
    </SnackbarProvider>
  );
};

export default ToastList;
